import { apiClient } from "../../utils/apiClient";
import { citaUser } from "../../types/citaUser";
import { Cita } from "../../types/cita";
import { AppointmentCheckIn } from "../../types/appointmentCheckIn";
import { AppointmentCheckOut } from "../../types/appointmentCheckOut";

export const fetchAppointmentsByDate = async (
  searchDate: string,
): Promise<any[]> => {
  return apiClient
    .get(`/appointments/byDate?searchDate=${searchDate}`)
    .then((response) => response.data);
};

export const fetchAcommpanantesByVisitaId = async (
  appointmentId: number,
): Promise<any[]> => {
  return apiClient
    .get(`/appointments/acompanantes/${appointmentId}`)
    .then((response) => response.data);
};

export const fetchUsers = async (searchTerm: string): Promise<citaUser[]> => {
  return apiClient
    .get(`/appointments/users?searchTerm=${searchTerm}`)
    .then((response) => response.data);
};

export const postCita = async (appointment: Cita): Promise<any> => {
  return apiClient
    .post("/appointments", appointment)
    .then((response) => response.data);
};

export const postCheckIn = async (
  appointmentCheckIn: AppointmentCheckIn,
): Promise<any> => {
  return apiClient
    .post("appointments/check-in", appointmentCheckIn)
    .then((response) => response.data);
};

export const postCheckOut = async (
  appointmentCheckOut: AppointmentCheckOut,
): Promise<any> => {
  return apiClient
    .post("appointments/check-out", appointmentCheckOut)
    .then((response) => response.data);
};
